import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer.js';
import Teambackend from '../components/Teambackend.js';


import arshad from "../components/img/team/arshad.webp";
import mirza from "../components/img/team/mirza.webp";
import pande from "../components/img/team/pande.webp";
import ranjit from "../components/img/team/ranjit.webp";
import sonpure from "../components/img/team/sonpure.webp";
import verma from "../components/img/team/verma.webp";


export default function Team() {
    return (
        <>
            

            <Header />

           

            <div className="container-fluid bg-breadcrumb bg-pattern ">
            <div className="container text-center ">
                <h3 className="text-white  mb-4">Our Leadership</h3>   
            </div>
        </div>



            {/* Team Content Area */}
            <div className="team-section mt-5">
                <div className="container">
                    
                    <div class="row g-4">
            <div class="col-lg-4 col-md-6">
                <div class="team-card featured">
                    <div class="team-img-wrapper">
                        <img src={sonpure} alt="Dr. K. R. Sonpure" class="team-img"/>
                        <div class="team-social">
                            <a href="#"><i class="fab fa-linkedin-in"></i></a>
                        </div>
                    </div>
                    <div class="team-info">
                        <h5>Dr. K. R. Sonpure</h5>
                        <span class="designation">Chief Patron &amp; Principal Advisor</span>
                        <p class="team-bio-short mt-2">Member Invitee Adiwasi Vikas Adhave Samiti Govt Of Maharashtra, ex OSD Honble Chief Minister Secretariat.</p>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="team-card">
                    <div class="team-img-wrapper">
                        <img src={arshad} alt="Dr. Arshad Tanvir Khan" class="team-img"/>
                        <div class="team-social">
                            <a href="#"><i class="fab fa-linkedin-in"></i></a>
                        </div>
                    </div>
                    <div class="team-info">
                        <h5>Dr. Arshad Tanvir Khan</h5>
                        <span class="designation">Secretary, MHW, PHD</span>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="team-card">
                    <div class="team-img-wrapper">
                        <img src={ranjit} alt="Adv. Ranjit Sardey" class="team-img"/>
                        <div class="team-social">
                            <a href="#"><i class="fab fa-linkedin-in"></i></a>
                        </div>
                    </div>
                    <div class="team-info">
                        <h5>Adv. Ranjit Sardey</h5>
                        <span class="designation">Legal Advisor</span>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="team-card">
                    <div class="team-img-wrapper">
                        <img src={pande} alt="Adv. Ravindra Pande" class="team-img"/>
                        <div class="team-social">
                            <a href="#"><i class="fab fa-linkedin-in"></i></a>
                        </div>
                    </div>
                    <div class="team-info">
                        <h5>Adv. Ravindra Pande</h5>
                        <span class="designation">Vice President</span>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="team-card">
                    <div class="team-img-wrapper">
                        <img src={mirza} alt="Jamal Nasir Mirza" class="team-img"/>
                        <div class="team-social">
                            <a href="#"><i class="fab fa-linkedin-in"></i></a>
                        </div>
                    </div>
                    <div class="team-info">
                        <h5>Jamal Nasir Mirza</h5>
                        <span class="designation">Joint Secretary</span>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="team-card">
                    <div class="team-img-wrapper">
                        <img src={verma} alt="Dinesh Verma" class="team-img"/>
                        <div class="team-social">
                            <a href="#"><i class="fab fa-linkedin-in"></i></a>
                        </div>
                    </div>
                    <div class="team-info">
                        <h5>Dinesh Verma</h5>
                        <span class="designation">Executive Member</span>
                    </div>
                </div>
            </div>

        </div>


                </div>
            </div>

            <Footer />

            <style>
                {`
                .team-card {
    background: #fff;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 10px 30px rgba(0,0,0,0.05);
    transition: all 0.3s ease;
    height: 100%;
    border-bottom: 4px solid transparent;
}

.team-card:hover {
    transform: translateY(-10px);
    border-bottom: 4px solid #C5A059; /* Gold color */
}

.team-img-wrapper {
    position: relative;
    height: 320px;
    overflow: hidden;
}

.team-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.5s ease;
}

.team-card:hover .team-img {
    transform: scale(1.05);
}

.team-social {
    position: absolute;
    bottom: -50px;
    left: 0;
    right: 0; 
    padding: 15px;
    text-align: center;
    transition: all 0.3s ease;
}

.team-card:hover .team-social {
    bottom: 0;
}

.team-social a {
    color: #fff;
    font-size: 1.2rem;
}

.team-info {
    padding: 25px;
    text-align: center;
}

.team-info h5 {
    font-family: 'Cinzel', serif;
    font-weight: 700;
    color: #0A3830;
    margin-bottom: 5px;
}

.designation {
    color: #C5A059;
    font-size: 0.85rem;
    text-transform: uppercase;
    letter-spacing: 1px;
    font-weight: 600;
    display: block;
}

.team-bio-short {
    font-size: 0.8rem;
    color: #666;
    line-height: 1.4;
}

/* Responsive Adjustments */
@media (max-width: 768px) {
    .team-img-wrapper {
        height: 280px;
    }
}



`}
            </style>
        </>
    );
}